import UserAvatar from '../../User/UserAvatar'

const FeaturedBanner = ({ data }) => {
  const topic = data[0]
  const author = topic.firstPost.author

  return (
    <a className='box banner-notification notification' href={topic.url}>
      <div className='box__content box__pad'>
        <p className='notification-title'>
          <span className='notification-link'>
            { topic.title.length > 100 ? topic.title.substring(0, 100) + '...' : topic.title }
          </span>
        </p>
        <span className='thread-meta-item'>
          <UserAvatar
            user={author}
            extraClass='avatar avatar--S'
            showRank
          />
          <span className='notification-link'>
            <span className='thread-meta-item__date'>
              { topic.firstPost.relativeCreationDate }
            </span>
          </span>
        </span>
      </div>
    </a>
  )
}

export default FeaturedBanner
